import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { BatteryCharging, BatteryWarning } from "lucide-react";
import { ViewMgtDeviceStatusValue } from "./ViewMgtDeviceStatusValue";

export default function ViewMgtDeviceStatusInternalBattery({ device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {

  const batteryStatusLog = device?.BatteryStatusLog;
  
  return (
    <ViewMgtDevicePanel title="Internal Battery" icon={ batteryStatusLog?.internalBatteryCharging ? <BatteryCharging size={16} /> : <BatteryWarning size={16} /> }>
      <div className="grid grid-cols-1 gap-0">
        
        <ViewMgtDeviceStatusValue 
          label="Status"
          value={device?.BatteryStatusLog?.internalBatteryCharging ? "Charging" : "Not Charging"}
          color={device?.BatteryStatusLog?.internalBatteryCharging ? "text-green-500" : "text-red-500"}
          timestamp={device?.BatteryStatusLog?.logTimestamp}
          />

        <ViewMgtDeviceStatusValue 
          label="Voltage"
          color="text-slate-500"
          timestamp={device?.BatteryStatusLog?.logTimestamp}
          value={`${device?.BatteryStatusLog?.internalBatteryVoltageMilli} millivolts`}
          />

      </div>
    </ViewMgtDevicePanel>
  );
}
